import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tables',
  templateUrl: './tables.component.html',
  styleUrls: ['./tables.component.scss']
})
export class TablesComponent implements OnInit {
  viewTab: boolean = true;
  htmlTab: boolean;
  viewTab1: boolean = true;
  htmlTab1: boolean;
  viewTab2: boolean = true;
  htmlTab2: boolean;
  viewTab3: boolean = true;
  htmlTab3: boolean;
  viewTab4: boolean = true;
  htmlTab4: boolean;
  viewTab5: boolean = true;
  htmlTab5: boolean;
  viewTab6: boolean = true;
  htmlTab6: boolean;

  constructor() { }

  ngOnInit(): void {
  }


  onMenuTab(number) {
    this.viewTab = false;
    this.htmlTab = false;

    if (number == '1') {
      this.viewTab = true;
    }
    else if (number == '2') {
      this.htmlTab = true;
    }
  }

  onMenuTab1(number) {
    this.viewTab1 = false;
    this.htmlTab1 = false;

    if (number == '1') {
      this.viewTab1 = true;
    }
    else if (number == '2') {
      this.htmlTab1 = true;
    }
  }

  onMenuTab2(number) {
    this.viewTab2 = false;
    this.htmlTab2 = false;

    if (number == '1') {
      this.viewTab2 = true;
    }
    else if (number == '2') {
      this.htmlTab2 = true;
    }
  }

  onMenuTab3(number) {
    this.viewTab3 = false;
    this.htmlTab3 = false;

    if (number == '1') {
      this.viewTab3 = true;
    }
    else if (number == '2') {
      this.htmlTab3 = true;
    }
  }

  onMenuTab4(number) {
    this.viewTab4 = false;
    this.htmlTab4 = false;

    if (number == '1') {
      this.viewTab4 = true;
    }
    else if (number == '2') {
      this.htmlTab4 = true;
    }
  }

  onMenuTab5(number) {
    this.viewTab5 = false;
    this.htmlTab5 = false;

    if (number == '1') {
      this.viewTab5 = true;
    }
    else if (number == '2') {
      this.htmlTab5 = true;
    }
  }

  onMenuTab6(number) {
    this.viewTab6 = false;
    this.htmlTab6 = false;

    if (number == '1') {
      this.viewTab6 = true;
    }
    else if (number == '2') {
      this.htmlTab6 = true;
    }
  }

}
